// core
import { deDE as deDECore, enUS as enUSCore } from '@mui/material/locale';
// date-pickers
import {
  deDE as deDEDate,
  enUS as enUSDate
} from '@mui/x-date-pickers/locales';
import { de as deDEAdapter, enUS as enUSAdapter } from 'date-fns/locale';
import merge from 'lodash/merge';
import { locales } from './constants';
import { AppLocale } from './types';

export const allLangs = {
  [AppLocale.de_DE]: {
    label: 'German',
    value: AppLocale.de_DE,
    systemValue: merge(deDEDate, deDECore),
    adapterLocale: deDEAdapter,
    locale: locales[AppLocale.de_DE]
  },
  [AppLocale.en_US]: {
    label: 'English',
    value: AppLocale.en_US,
    systemValue: merge(enUSDate, enUSCore),
    adapterLocale: enUSAdapter,
    locale: locales[AppLocale.en_US]
  }
};

export const defaultLang = allLangs[AppLocale.de_DE];
